import React, { Children, isValidElement } from 'react'

export default function joinComponents(components, separator) {
  const joinedComponents = components.map((component, index) => (
    <>
      {component}
      {index < components.length - 1 && separator}
    </>
  ))

  return <span>{joinedComponents}</span>
}

export function extractTextFromComponent(component) {
  const textContent = []

  function traverse(children) {
    Children.forEach(children, (child) => {
      if (typeof child === 'string') {
        textContent.push(child)
      } else if (isValidElement(child)) {
        traverse(child.props.children)
      }
    })
  }
  traverse(component.props.children)

  return textContent.join(', ')
}
